export const DEFAULT_LABELS = {
	info_text:
		'Responses will be shared only with select registered Expo West/Newtopia Now investors and Nutrition Capital Network’s investor network and will not be shared on Beacon Discovery.',
	activelyRaisingCapitalC: 'Are you actively raising capital?',
	revenueLastYear: 'Revenue last year (in USD):',
	revenueExpectedThisYear: 'Revenue expected this year (in USD):'
};
